"use client";

import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";

/**
 * Memastikan setiap pindah halaman selalu dimulai dari atas.
 *
 * Next.js tidak menggulir ke atas jika bagian atas halaman baru masih berada di
 * dalam layar. Karena header kita sticky, halaman baru kadang terbuka sedikit ke
 * bawah (bila sebelumnya halaman hanya digulir sedikit). Komponen ini menutup celah itu.
 * - Tombol Back/Forward browser tetap memakai posisi gulir yang diingat browser.
 * - Tautan dengan #anchor tetap diarahkan ke bagian yang dituju.
 */
export function ScrollToTop() {
  const pathname = usePathname();
  const isFirstRender = useRef(true);
  const isHistoryNav = useRef(false);

  useEffect(() => {
    const onPopState = () => {
      isHistoryNav.current = true;
    };
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, []);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (isHistoryNav.current) {
      isHistoryNav.current = false;
      return;
    }
    if (window.location.hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
